


























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { ApplicationState, CurrentSelectedFilters, FilterSymbol, PriceOptimizerState } from "@/models";
import ApplicationModule from "@/store/modules/application";
import PriceOptimizerModule from "@/store/modules/price-optimizer";
import moment from "moment";
import { formatDate } from "@/helpers/functions/format-date";

const application = namespace(ApplicationModule.name);
const priceOptimizer = namespace(PriceOptimizerModule.name);

@Component({
  name: "FilterOptions"
})
export default class FilterOptions extends Vue {
  // ===== Store ===== //
  @State("application") private application!: ApplicationState;
  @State("priceOptimizer") private priceOptimizer!: PriceOptimizerState;
  @application.Getter("facilityUnitTypes")
    public facilityUnitTypes!: () => string[];
  @priceOptimizer.Action("updateCurrentSelectedFilters")
    public updateCurrentSelectedFilters!: (newVal: CurrentSelectedFilters) => void;
  @priceOptimizer.Action("removeSelectedFilter") public removeSelectedFilter!: (newVal: number) => void;

  // ===== Props ===== //
  @Prop(Object) filter!: CurrentSelectedFilters;

  // ===== Data ===== //
  public compPriceRange = [
    { parameter: "market_rate_min_pct", value: "low" },
    { parameter: "market_rate_avg_pct", value: "average" },
    { parameter: "market_rate_max_pct", value: "high" }
  ];
  public symbols: FilterSymbol[] = [
    { filter: "[lt]", value: "less than" },
    { filter: "[lte]", value: "less than or equals" },
    { filter: "[eq]", value: "equal to" },
    { filter: "[gt]", value: "greater than" },
    { filter: "[gte]", value: "greater than or equals" }
  ];

  public gpiMenu = false;

  public standardRateItems = [
    { text: "IPR Low", value: "ipr_min" },
    { text: "IPR Average", value: "ipr_avg" },
    { text: "IPR High", value: "ipr_max" },
    { text: "Market Rate Low", value: "market_rate_min" },
    { text: "Market Rate Average", value: "market_rate_avg" },
    { text: "Market Rate High", value: "market_rate_max" }
  ]

  // ===== Methods ===== //
  public formatDate = formatDate;
  public async cancelFilter(id: number) {
    await this.removeSelectedFilter(id);
  }

  // ===== Computed ===== //

  get unitTypeNameFilter(): boolean {
    return this.filter.type_selected.parameter === "unit_type_name";
  }

  get compPriceChange(): boolean {
    return this.filter.type_selected.value === "Competitor Pricing Change +/-";
  }

  get facilityLocation(): boolean {
    return this.filter.type_selected.parameter === "facility_unit_type.facility.location_code";
  }

  get gpi(): boolean {
    return this.filter.type_selected.parameter === "revenue_gpi_pct";
  }

  get lastRateIncrease(): boolean {
    return this.filter.type_selected.parameter === "days_since_last_rate_change";
  }

  get rentRateSqFt(): boolean {
    return this.filter.type_selected.parameter === "total_rate_per_square_foot";
  }

  get uniqueVisitors(): boolean {
    return this.filter.type_selected.parameter === "unique_visitors";
  }

  get standardRate(): boolean {
    return this.filter.type_selected.parameter === "facility_unit_types_current_rate";
  }

  get filterTypeSelected(): string|string[] {
    if (this.compPriceChange) {
      return this.filter.type_selected.value && this.filter.comp_price_selected.value;
    }
    if (this.unitTypeNameFilter) {
      return "";
    }
    return this.filter.type_selected.value;
  }

  /* istanbul ignore next */
  get formattedGpiDate(): string {
    if (this.filter.gpi_date === "") {
      return "";
    }

    return this.formatDate(this.filter.gpi_date);
  }

  /* istanbul ignore next */
  get proceedFilterStep(): string | number {
    if (this.compPriceChange) {
      return this.filter.type_selected.value && this.filter.comp_price_selected.value && this.filter.symbol_selected.filter;
    }
    return this.filter.type_selected.value && this.filter.symbol_selected.filter;
  }

  get showNumberField(): boolean {
    if (
      this.proceedFilterStep &&
      !this.gpi &&
      !this.facilityLocation &&
      !this.standardRate &&
      !this.unitTypeNameFilter
    ) {
      return true;
    }
    return false;
  }

  get descriptionFilters(): boolean {
    return this.rentRateSqFt || this.compPriceChange;
  }

  /* istanbul ignore next */
  get filteredSymbols(): object {
    if (this.compPriceChange || this.gpi) {
      return this.symbols.filter(symbol => symbol.filter !== "[eq]");
    }
    if (this.facilityLocation) {
      return this.symbols.filter(symbol => symbol.filter === "[eq]");
    }

    return this.symbols;
  }

  /* istanbul ignore next */
  get minDate(): string {
    return moment().utc().month(0).date(1).year(2018).format("YYYY-MM-DD");
  }

  // ===== Watch ===== //
  @Watch("filter.type_selected")
  public handleFacilitySymbol() {
    /* istanbul ignore next */
    if (this.facilityLocation) {
      this.filter.symbol_selected = { filter: "[eq]", value: "equal to" };
      this.filter.number_selected = "";
    }
    if (this.unitTypeNameFilter) {
      this.filter.symbol_selected = { filter: "[in]", value: "in" };
      this.filter.number_selected = "";
    }
  }
}
